import { generateCotizacionAutosDetalle } from '@/services/api';
import type { QuoteData } from '@/types/quote.types';
import type { QuoteGenerationContext } from './types';

export type GeneratedQuote = { Id_Cotizacion?: number; Id_Cotizacion_Autos_Detalle?: number };

const storeQuoteIds = (quoteData: QuoteData, cotizacion: GeneratedQuote): void => {
  if (cotizacion.Id_Cotizacion) {
    quoteData.cotizacionData ??= {};
    quoteData.cotizacionData.idCotizacion = Number(cotizacion.Id_Cotizacion);
  }
  if (cotizacion.Id_Cotizacion_Autos_Detalle) {
    quoteData.cotizacionData ??= {};
    quoteData.cotizacionData.idCotizacionAutosDetalle = Number(cotizacion.Id_Cotizacion_Autos_Detalle);
  }
};

const beginGenerate = (
  { state, loading }: QuoteGenerationContext,
  isUpdate: boolean,
  showLoadingScreen: boolean,
): void => {
  // The initial Insert runs silently: isLoading only flips when the loading screen is requested.
  if (showLoadingScreen) state.isLoading.value = true;
  state.error.value = null;
  if (!showLoadingScreen) return;
  const message = isUpdate ? 'Actualizando cotización...' : 'Generando cotización...';
  loading.showLoading(message, 'Por favor espere un momento...');
};

/** Insert or Update the quote and keep the returned ids on `quoteData`. */
export const runGenerateQuote = async (
  ctx: QuoteGenerationContext,
  quoteData: QuoteData,
  isUpdate: boolean,
  showLoadingScreen: boolean,
): Promise<GeneratedQuote | null> => {
  beginGenerate(ctx, isUpdate, showLoadingScreen);

  try {
    const cotizacion = await generateCotizacionAutosDetalle(quoteData, isUpdate);
    storeQuoteIds(quoteData, cotizacion);
    if (showLoadingScreen) ctx.loading.hideLoading();
    return cotizacion;
  } catch (err) {
    ctx.state.error.value = err instanceof Error ? err.message : 'Error al generar la cotización';
    console.error('❌ Error al generar la cotización:', err);
    if (showLoadingScreen) ctx.loading.hideLoading();
    throw err;
  } finally {
    if (showLoadingScreen) ctx.state.isLoading.value = false;
  }
};
